import React from "react";

/** MUI */
import { makeStyles } from "@material-ui/core/styles";
import { CssBaseline, Container } from "@material-ui/core";

const Header = React.lazy(() => import('../common/Header'))
const Footer = React.lazy(() => import('../common/Footer'))

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        minHeight: '100vh',
        padding: 0,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'baseline'
    },
    header: {
        width: '100%'
    },
    main: {
        width: '100%',
        marginTop: theme.spacing(8),
        minHeight: 'calc(100vh - 112px)'
    },
    footer: {
        width: '100%'
    }
}));

const MainView = props => {
    const classes = useStyles();
    return <>
        <CssBaseline />

        <Container maxWidth={false} className={classes.root}>

            <header className={classes.header}>
                <Header />
            </header>

            <main className={classes.main}>
                {props.children}
            </main>

            <footer className={classes.footer}>
                <Footer />
            </footer>

        </Container>
    </>
}

export default MainView;
